import {
	API_ERROR,
	GET_USER_PERMISSIONS,
	USER_PERMISSIONS_SUCCESSFUL,
	GET_LOCATIONS,
	LOCATION_LIST_SUCCESSFUL,
	GET_SUB_LOCATIONS,
	SUB_ORDER_LOCATIONS_LIST,
	SUB_LOCATION_LIST_SUCCESSFUL,
	GET_USER_LOCATIONS,
	USER_LOCATION_LIST_SUCCESSFUL,
	GET_USER_SUB_LOCATIONS,
	USER_SUB_LOCATION_LIST_SUCCESSFUL,
	SUB_ORDER_LOCATION_LIST_SUCCESSFUL,
	GET_DEPARTMENT,
	DEPARTMENT_LIST_SUCCESSFUL,
	GET_USER_DEPARTMENT,
	USER_DEPARTMENT_LIST_SUCCESSFUL,
	GET_STATE,
	STATE_LIST_SUCCESSFUL,
	GET_VENDORS,
	VENDORS_LIST_SUCCESSFUL,
	GET_VENDORS2,
	VENDORS2_LIST_SUCCESSFUL,
	GET_SECTION,
	SECTION_LIST_SUCCESSFUL,
	GET_CATEGORY,
	CATEGORY_LIST_SUCCESSFUL,
	GET_TAX,
	TAX_LIST_SUCCESSFUL,
	GET_BASICUNIT,
	BASICUNIT_LIST_SUCCESSFUL,
	GET_MINI_PRODUCT_GROUPS_LIST,
	MINI_PRODUCT_GROUPS_LIST_SUCCESSFUL,
	GET_SUBLOCATIONS2,
	SUBLOCATIONS2_LIST_SUCCESSFUL,
	SUBLOCATIONS2_CHANGE_PARAMS,
	CLEAR_SUBLOCATIONS2_LIST,
	GET_MINI_PRODUCT_LIST,
	MINI_PRODUCT_LIST_SUCCESSFUL,
	CLEAR_VENDORS_LIST,
	MINI_SUB_ORDER_LOCATIONS_LIST,
	MINI_SUB_ORDER_LOCATION_LIST_SUCCESSFUL,
	GET_ProductQualities,
	ProductQualities_LIST_SUCCESSFUL,
	GET_MINI_QUALITY_LIST,
	MINI_QUALITY_LIST_SUCCESSFUL,
} from "./actionTypes";

export const getUserPermissions = () => {
	return {
		type: GET_USER_PERMISSIONS,
	};
};
export const userPermissionsSuccessful = (response) => {
	return {
		type: USER_PERMISSIONS_SUCCESSFUL,
		payload: { response },
	};
};

export const getMiniLocations = () => {
	return {
		type: GET_LOCATIONS,
	};
};
export const locationListSuccessful = (response) => {
	return {
		type: LOCATION_LIST_SUCCESSFUL,
		payload: { response },
	};
};

export const getMiniQUALITY = (params) => ({
	type: GET_MINI_QUALITY_LIST,
	payload: params,
});


export const QUALITYListSuccessful = ({ response, params }) => {
	// ✅ make sure it always passes a wrapped structure
	const formattedResponse = Array.isArray(response)
		? { results: response, count: response.length }
		: response;

	return {
		type: MINI_QUALITY_LIST_SUCCESSFUL,
		payload: { response: formattedResponse, params },
	};
};

export const getMiniProductQualities = (params) => {
	return {
		type: GET_ProductQualities,
		payload: params,
	};
};
export const productQualitiesistSuccessful = (data) => {
	return {
		type: ProductQualities_LIST_SUCCESSFUL,
		payload: data,
	};
};

export const getMiniSubLocations = (id) => {
	return {
		type: GET_SUB_LOCATIONS,
		payload: { id },
	};
};

export const getMiniSubOrderLocations = (location_id, sublocation_id) => {
	return {
		type: SUB_ORDER_LOCATIONS_LIST,
		payload: { location_id, sublocation_id },
	};
};
export const sublocationListSuccessful = (response) => {
	return {
		type: SUB_LOCATION_LIST_SUCCESSFUL,
		payload: { response },
	};
};

export const suborderlocationListSuccessful = (response) => {
	return {
		type: SUB_ORDER_LOCATION_LIST_SUCCESSFUL,
		payload: { response },
	};
};

export const getSubOrderLocations = () => {
	return {
		type: MINI_SUB_ORDER_LOCATIONS_LIST,
	};
};

export const minisuborderlocationListSuccessful = (response) => {
	return {
		type: MINI_SUB_ORDER_LOCATION_LIST_SUCCESSFUL,
		payload: { response },
	};
};
export const getUserLocations = () => {
	return {
		type: GET_USER_LOCATIONS,
	};
};
export const userLocationListSuccessful = (response) => {
	return {
		type: USER_LOCATION_LIST_SUCCESSFUL,
		payload: { response },
	};
};
export const getUserSubLocations = (id) => {
	return {
		type: GET_USER_SUB_LOCATIONS,
		payload: { id },
	};
};
export const userSubLocationListSuccessful = (response) => {
	return {
		type: USER_SUB_LOCATION_LIST_SUCCESSFUL,
		payload: { response },
	};
};
export const getMiniDepartment = () => {
	return {
		type: GET_DEPARTMENT,
	};
};
export const DepartmentListSuccessful = (response) => {
	return {
		type: DEPARTMENT_LIST_SUCCESSFUL,
		payload: { response },
	};
};

export const getUserDepartment = (cb) => {
	return {
		type: GET_USER_DEPARTMENT,
		payload: { cb },
	};
};
export const UserDepartmentListSuccessful = (response) => {
	return {
		type: USER_DEPARTMENT_LIST_SUCCESSFUL,
		payload: { response },
	};
};
export const getState = () => {
	return {
		type: GET_STATE,
	};
};

export const stateListSuccessful = (response) => {
	return {
		type: STATE_LIST_SUCCESSFUL,
		payload: { response },
	};
};
export const getMiniVendors = (params) => {
	return {
		type: GET_VENDORS,
		payload: params,
	};
};
export const clearMiniVendors = () => {
	return {
		type: CLEAR_VENDORS_LIST,
	};
};

export const vendorListSuccessful = (response, params) => {
	return {
		type: VENDORS_LIST_SUCCESSFUL,
		payload: { response, params },
	};
};
export const getMini2Vendors = () => {
	return {
		type: GET_VENDORS2,
	};
};

export const vendor2ListSuccessful = (response) => {
	return {
		type: VENDORS2_LIST_SUCCESSFUL,
		payload: { response },
	};
};

export const getMini2SubLocations = (data) => {
	return {
		type: GET_SUBLOCATIONS2,
		payload: { data },
	};
};
export const clearMini2SubLocations = (data) => {
	return {
		type: CLEAR_SUBLOCATIONS2_LIST,
	};
};

export const sub2LocationSuccessful = (response) => {
	return {
		type: SUBLOCATIONS2_LIST_SUCCESSFUL,
		payload: { response },
	};
};
export const setSub2LocationParams = (data) => {
	return {
		type: SUBLOCATIONS2_CHANGE_PARAMS,
		payload: { ...data },
	};
};

export const getMiniSections = () => {
	return {
		type: GET_SECTION,
	};
};

export const SectionListSuccessful = (response) => {
	return {
		type: SECTION_LIST_SUCCESSFUL,
		payload: { response },
	};
};
export const getMiniCategorys = () => {
	return {
		type: GET_CATEGORY,
	};
};

export const CategoryListSuccessful = (response) => {
	return {
		type: CATEGORY_LIST_SUCCESSFUL,
		payload: { response },
	};
};
export const getMiniTaxs = () => {
	return {
		type: GET_TAX,
	};
};

export const TaxListSuccessful = (response) => {
	return {
		type: TAX_LIST_SUCCESSFUL,
		payload: { response },
	};
};
export const getMiniBasicUnits = () => {
	return {
		type: GET_BASICUNIT,
	};
};
export const BasicUnitListSuccessful = (response) => {
	return {
		type: BASICUNIT_LIST_SUCCESSFUL,
		payload: { response },
	};
};

export const getMiniProductGroupsList = () => {
	return {
		type: GET_MINI_PRODUCT_GROUPS_LIST,
	};
};
export const ProductMiniGroupsListSuccessful = (response) => {
	return {
		type: MINI_PRODUCT_GROUPS_LIST_SUCCESSFUL,
		payload: { response },
	};
};
// export const getMiniProductList = () => {
// 	return {
// 		type: GET_MINI_PRODUCT_LIST,
// 	};
// };

export const getMiniProductList = (params) => {
	return {
		type: GET_MINI_PRODUCT_LIST,
		payload: params,
	};
};
export const ProductMiniListSuccessful = (data) => {
	return {
		type: MINI_PRODUCT_LIST_SUCCESSFUL,
		payload: data,
	};
};
export const apiError = (error) => {
	return {
		type: API_ERROR,
		payload: error,
	};
};
